import { useEffect, useState } from 'react'
import useIsEqualMemoization from './useIsEqualMemoization'

function useDraft(value) {
  const memoizedValue = useIsEqualMemoization(value)
  const [draft, setDraft] = useState(memoizedValue)

  useEffect(() => {
    setDraft(memoizedValue)
  }, [memoizedValue])

  return [draft, setDraft]
}

export default useDraft
